import { useSelector } from "react-redux";
import { useActions } from "./useActions";
import {
    openCoverageInfoModal,
    closeCoverageInfoModal,
} from "../redux/home-insurance/home-insurance.actions";
import Datalayer from "../libs/vendors/data-layer";
import { CLICK_ACTIONS, CLICK_DESCRIPTION } from "../constants/datalayer";
import { COVERAGES_CODES, COVERAGES_CODES_TRADUCTION } from "../constants/coverages";

export default function useCoverageModal() {
    const coverageInfoModal = useSelector(state => state.HomeInsurance.coverageInfoModal);
    const actions = useActions({
        openCoverageInfoModal,
        closeCoverageInfoModal,
    });
    return {
        coverageInfoModal,
        openCoverageInfoModal: code => {
            Datalayer.sendClickAction(
                "Cotización",
                `${CLICK_ACTIONS.COVERAGE} ${
                    code === COVERAGES_CODES.PRIME ? "principal" : "opcionales"
                }: ${
                    code === COVERAGES_CODES.PRIME
                        ? CLICK_DESCRIPTION.PRIME_COVERAGE
                        : COVERAGES_CODES_TRADUCTION[code]
                }`
            );
            actions.openCoverageInfoModal(code);
        },
        closeCoverageInfoModal: actions.closeCoverageInfoModal,
    };
}
